import React, { FC } from 'react'
import styled from 'styled-components'

const SHORT_HASH_LENGTH = 7

// Treat "HEAD" as missing so we never display it (build should pass actual commit)
const version =
  process.env.NEXT_PUBLIC_APP_VERSION && process.env.NEXT_PUBLIC_APP_VERSION !== 'HEAD'
    ? process.env.NEXT_PUBLIC_APP_VERSION
    : undefined
const isDevelopment = process.env.NODE_ENV !== 'production'
const shortVersion = version
  ? version.length > SHORT_HASH_LENGTH
    ? version.slice(0, SHORT_HASH_LENGTH)
    : version
  : undefined
const displayVersion = isDevelopment
  ? shortVersion
    ? `development-${shortVersion}`
    : 'development'
  : shortVersion ?? 'dev'

const badgeLabel = `Build: ${displayVersion}`

const AppVersionBadge: FC = () => {
  return <Badge title={badgeLabel}>{badgeLabel}</Badge>
}

const Badge = styled.span`
  position: fixed;
  bottom: 8px;
  left: 8px;
  z-index: 0;
  font-size: 11px;
  color: #98a2b3;
  background: rgba(0, 0, 0, 0.04);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
  pointer-events: none;
`

export default AppVersionBadge
